import { EventEmitter } from 'events';
import $ from 'jquery';

import * as Constants from './../../constants/Constants';
import * as VideoStore from './../../stores/video-store';

import { VideoPanel } from './../video/VideoPanel';

const host = Constants.getHost();

export class StaffPanel extends EventEmitter {
    constructor() {
        super();

        this.videos = VideoStore.get();

        this.videoPanel = new VideoPanel();
        this.staffPanel = $('.staffPanel');
        this.staffBtn = $('.staff-button');

        this._initVideos();
        this._onBtnClick();
        this._onVideoListClick();
    }

    _initVideos() {
        for(let i=0; i<this.videos.length; i++) {
            const name = this.videos[i].name;
            const url = host + this.videos[i].url;
            this.staffPanel.append('<li data-url="' + url +'" class="video-list">' + name + '</li>');
        }
    }

    _onBtnClick() {
        this.staffBtn.click( () => {
            this._toggleButton();
            this._togglePanel();
        });
    }
    _togglePanel() {
        if( this.staffPanel.hasClass('active')) {
            this.staffPanel.removeClass('active');
            return;
        }
        this.staffPanel.addClass('active');
    }

    _toggleButton() {
        const icon = this.staffBtn.find('button');

        if( this.staffPanel.hasClass('active')) {
            icon.removeClass('icon-close').addClass('icon-video');
            return;
        }
        icon.removeClass('icon-video').addClass('icon-close');
    }

    _onVideoListClick() {
        const that = this;
        $('.video-list').each( function() {
            $(this).click( function() {
                const src = $(this).data('url');
                that.videoPanel.fullscreen();
                that._updateVideo(src);
                that._toggleButton();
                that._togglePanel();
            });
        });
    }

    _updateVideo(videoUrl) {
        // const videoUrl = `./assets/video/${name}.mp4`;
        this.videoPanel.setSrc(videoUrl);

        this.videoPanel.play();
    }
}
